
<template>
  <div class="weather">
    <div id="he-plugin-standard"></div>
  </div>
</template>         
<script>
window.WIDGET = {
   "CONFIG": {
    "modules": "02",
    "background": "5",
    "tmpColor": "FFFFFF",
    "tmpSize": "16",
    // "cityColor": "FFFFFF",
    // "citySize": "16",
    "aqiColor": "FFFFFF",
    "aqiSize": "16",
    "weatherIconSize": "40",
    "alertIconSize": "18",
    "padding": "10px 10px 10px 10px",
    "shadow": "0",
    "language": "auto",
    "fixed": "false",
    "vertical": "top",
    "horizontal": "left",
    "key": "da4a2e7ff5cd4a17a666dc551e5ad9ed"
  }
}
import { defineComponent, onMounted } from "vue";
export default defineComponent({
    //vue2.x写法
    mounted() {
      this.$nextTick(() => {
        this.load()
      })
    },
    methods: {
      load() {
        const s = document.createElement('script')
        s.type = 'text/javascript'
        s.src =
          'https://widget.qweather.net/standard/static/js/he-standard-common.js?v=2.0'
        document.body.appendChild(s)
      },
    },
 
  //vue3.0的写法
  // setup() {
  //   onMounted(() => {
  //       weather()
  //   });
  //   const weather = () => {
  //     const s = document.createElement("script");
  //     s.type = "text/javascript";
  //     s.src =
  //       "https://widget.qweather.net/standard/static/js/he-standard-common.js?v=2.0";
  //     document.body.appendChild(s);
  //   };
 
  //   return {};
  // }
});
</script>
<style scoped>
.weather {
  width: 60px !important;
  height: 100%;
}
.wv-lt-refresh{
display: none;
}
</style>